import type { TripAccessorialDecisionInput } from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import type { ActualSourceKind } from '../trip-timeline/trip-timeline.api';

/** `GET /trips/:id/accessorials` and `POST /trips/:id/accessorials/decisions`, mirroring the API's view (gitaumoses4/chukua#120). */
export interface ProposalEvidence {
  eventId: string;
  eventType: string;
  kind: ActualSourceKind;
  deviceTime: string;
  serverTime: string;
}

export type DecisionKind = 'confirmed' | 'adjusted' | 'dropped';
export type ProposalState = 'open' | DecisionKind | 'stale';

export interface AccessorialDecision {
  id: string;
  proposalKey: string;
  accessorialTypeCode: string;
  decision: DecisionKind;
  quantity: number;
  unitAmountMinor: number;
  currency: string;
  amountMinor: number;
  reason: string | null;
  decidedBy: string;
  decidedAt: string;
  correctsDecisionId: string | null;
}

export interface AccessorialProposal {
  proposalKey: string;
  accessorialTypeCode: string;
  quantity: number;
  unitAmountMinor: number;
  currency: string;
  amountMinor: number;
  reason: string;
  evidence: ProposalEvidence[];
  onlyDriverTap: boolean;
  basisHash: string;
  state: ProposalState;
  decision: AccessorialDecision | null;
}

export type SkipReason = 'no_price_on_job' | 'nothing_due' | 'no_data' | 'waiting_start_event_missing' | 'diversion_not_supported';

export interface TripAccessorials {
  tripId: string;
  tripStatus: string;
  /** Why nothing can be decided now, or null when it can. */
  locked: { reason: string } | null;
  proposals: AccessorialProposal[];
  retired: AccessorialDecision[];
  skipped: { type: string; reason: SkipReason }[];
  history: AccessorialDecision[];
}

export function getTripAccessorials(tripId: string): Promise<TripAccessorials> {
  return api<TripAccessorials>(`/trips/${tripId}/accessorials`);
}

export function decideTripAccessorial(tripId: string, input: TripAccessorialDecisionInput): Promise<TripAccessorials> {
  return api<TripAccessorials>(`/trips/${tripId}/accessorials/decisions`, { method: 'POST', body: JSON.stringify(input) });
}
